import { Context } from 'vm';
import { Strings } from '../strings';

export const Log_LoginFailed = (status: number) => `Login ${status} - Failed to log in`;
export const Log_LoginSuccess = (upn: string) => `Login 200 - Successfully authenticated: ${upn}`;

export const Log_Operation_Failed = (context: Context, operation: Strings.Op | Strings.Http, error: string) => `${operation} ${context}  Failed - Error: ${error}`;
export const Log_Operation_Succesful = (context: Context, operation: Strings.Op | Strings.Http, message: string) => `${operation} ${context} - ${message}`;